// =============================================================================
// app/src/lib/saidasDoDia.ts — "quem vendeu e quando", numa linha do fechamento.
//
// Pedido do dono (06/10/2026): na aba Pedidos, ver o nome de quem vendeu. O
// banco devolve `horas` e `vendedores` na mesma ordem (pecas_vendidas_no_dia);
// aqui as duas viram texto curto:
//   * um vendedor só ....... "09:12 · 11:40 — João"  (o nome não se repete)
//   * mais de um ........... "09:12 João · 11:40 Maria"
// Resposta sem `vendedores` (a API antiga, no minuto entre publicar o banco e o
// app) mostra só as horas, como era.
// =============================================================================

export function textoDasSaidas(horas: string[], vendedores?: string[] | null): string {
  const vs = vendedores ?? [];
  if (vs.length !== horas.length || vs.length === 0) return horas.join(' · ');
  const distintos = new Set(vs);
  if (distintos.size === 1) return `${horas.join(' · ')} — ${vs[0]}`;
  return horas.map((h, i) => `${h} ${vs[i]}`).join(' · ');
}
